import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import {
  AccordionType,
  PricingSelectorV2AccordionsProps,
} from './PricingSelectorV2Accordions';

export function parsePricingSelectorV2Accordions(
  accordions: ReadonlyArray<
    Queries.Maybe<Queries.ContentfulAccordion001>
  > | null,
): PricingSelectorV2AccordionsProps {
  const accordionsParsed = accordions?.map((accordion): AccordionType => {
    const { title, icon, detail, accordionContents } = accordion || {};

    // Parse each accordio
    return {
      title: title || '',
      icon: icon || '',
      detail: detail || '',
      accordionContent: accordionContents?.map((accordionContent) => {
        const { description, title, detail, inLineCards, disclaimer } =
          accordionContent || {};

        // Parse each accordion content
        return {
          description: {
            raw: description?.raw || '',
          },
          title: title || '',
          detail: detail || '',
          disclaimer: disclaimer || '',
          inLineCards: inLineCards?.map((inLineCard) => {
            const { title, description, image } = inLineCard || {};

            const parsedMedia = image
              ? getMobileAndDesktopFirstImage([image])
              : null;

            // Parse each in-line card
            return {
              title: title || '',
              description: description || '',
              desktopImage: parsedMedia?.desktopImage || null,
              mobileImage: parsedMedia?.mobileImage || null,
            };
          }),
        };
      }),
    };
  });

  return {
    accordions: accordionsParsed || [],
  };
}
